import { AuthParamsValues } from '$core/models/auth-modals-query-params';
import { UserTypes } from '$core/models/user';

export const isAuthParamsAreRight = (
  userTypeParam?: string,
  authParam?: string
): boolean => {
  const isBothParamsAreSet = userTypeParam && authParam;

  if (!isBothParamsAreSet) {
    return false;
  }

  const isRightType = Object.values(UserTypes).includes(userTypeParam as any);
  const isRightAuth = Object.values(AuthParamsValues).includes(
    authParam as any
  );

  if (isRightType && isRightAuth) {
    return true;
  }

  return false;
};
